import CommonSearch from './CommonSearch';

export default function CustodianSearch({
  onSearchChanged,
}: Readonly<{
  onSearchChanged: (searchText?: string, entityType?: string) => void;
}>) {
  return (
    <CommonSearch
      title="Search Custodian"
      entityType="custodian"
      onSearchChanged={onSearchChanged}
    />
  );
}
